var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowGradient = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 78,
  viewBox: "0 0 12 78",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1H7ZM6 78L11.7735 68H0.226497L6 78ZM5 1V69H7V1H5Z",
  fill: "url(#paint0_linear_3572_32897)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3572_32897",
  x1: 6,
  y1: 40.0799,
  x2: 7.3592,
  y2: 40.0578,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4568DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B06AB3"
})))));
export { SvgArrowGradient as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNzgiIHZpZXdCb3g9IjAgMCAxMiA3OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMUM3IDAuNDQ3NzE1IDYuNTUyMjggMCA2IDBDNS40NDc3MiAwIDUgMC40NDc3MTUgNSAxSDdaTTYgNzhMMTEuNzczNSA2OEgwLjIyNjQ5N0w2IDc4Wk01IDFWNjlIN1YxSDVaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMzU3Ml8zMjg5NykiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8zNTcyXzMyODk3IiB4MT0iNiIgeTE9IjQwLjA3OTkiIHgyPSI3LjM1OTIiIHkyPSI0MC4wNTc4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM0NTY4REMiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjQjA2QUIzIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";